export const energies = [
	{ energyId: 0, energyName: 'Inner Gifts' },
	{ energyId: 1, energyName: 'Creativity through Security' },
	{ energyId: 2, energyName: 'Cooperation through Balance' },
	{ energyId: 3, energyName: 'Expression through Sensitivity' },
	{ energyId: 4, energyName: 'Stability through Process' },
	{ energyId: 5, energyName: 'Freedom through Discipline' },
	{ energyId: 6, energyName: 'Vision through Acceptance' },
	{ energyId: 7, energyName: 'Trust through Openness' },
	{ energyId: 8, energyName: 'Influence through Authority' },
	{ energyId: 9, energyName: 'Integrity through Wisdom' },
	{ energyId: 10, energyName: 'Creativity with Inner Gifts' },
	{ energyId: 11, energyName: 'Double Creativity' },
	{ energyId: 12, energyName: 'Creative Cooperation' }
]
